import { Schedule } from './schedule';
import { z } from 'zod';
import { TaskType } from './task';
export interface ScheduleSuperApi {
  resources: SuperApiResource[];
}

export interface SuperApiResource {
  events: SchedulerEvent[];
  resource: {
    id: string;
    name: string;
    externalId: string;
    role: string;
    team: string;
  };
  schedules: Schedule[];
}

export interface SchedulerEvent {
  claimNumber: string;
  endDateTime: string;
  eventName: string;
  reasonCode: string;
  externalId: string;
  insuredName: string;
  isTask: boolean;
  isRescheduleAllowed: boolean;
  peril: string;
  resourceId: string;
  source: string;
  startDateTime: string;
  taskReferenceId: string;
  tenantId: string;
  timeZoneId: string;
  data: SchedulerEvent;
  driveStartTime: string;
  lossLat: number;
  lossLong: number;
}

// new

export const SuperApiResource = z.object({
  id: z.string(),
  calendar: z.string(),
  externalId: z.string(),
  name: z.string(),
  role: z.string(),
  team: z.string(),
});

export const CalendarInterval = z.object({
  name: z.string(),
  iconCls: z.string(),
  source: z.string(),
  startDate: z.union([z.string(), z.date()]),
  endDate: z.union([z.string(), z.date()]),
  recurrentStartDate: z.union([z.date(), z.string()]),
  recurrentEndDate: z.union([z.date(), z.string()]),
  isWorking: z.boolean(),
});

export const SuperApiCalendar = z.object({
  id: z.string(),
  name: z.string(),
  unspecifiedTimeIsWorking: z.boolean(),
  intervals: z.array(CalendarInterval),
});

export const EVENT_TYPE = [
  'no-location',
  'event',
  'task',
  ...Object.values(TaskType),
] as const;

export const SuperApiTask = z.object({
  insuredName: z.string(),
  claimNumber: z.string(),
  isRescheduleAllowed: z.boolean(),
  driveStartTime: z.union([z.date(), z.string()]),
  homeArrivalTime: z.union([z.date(), z.string()]),
  peril: z.string(),
  id: z.string(),
  // Blocked-time events expose the externalId we sent on upsert; tasks
  // don't. Optional so existing task payloads still type-check.
  externalId: z.string().optional(),
  resourceId: z.string(),
  taskReferenceId: z.string(),
  name: z.string(),
  eventName: z.string(),
  startDate: z.union([z.string(), z.undefined()]),
  endDate: z.union([z.string(), z.undefined()]),
  source: z.string(),
  notes: z.string(),
  type: z.enum(EVENT_TYPE),
  targetQueue: z.string(),
  isTask: z.boolean(),
  reasonCode: z.string(),
  lossLat: z.number(),
  lossLong: z.number(),
  mustStartAfter: z.date().nullable(),
  mustEndBefore: z.date().nullable(),
  methodOfInspection: z.string().nullable(),
  taskType: z.string().nullable(),
  category: z.string().nullable(),
  isForced: z.boolean().nullable(),
  createdBy: z.string().nullable(),
  editedBy: z.string().nullable(),
});

export const SuperApiSchema = z.object({
  resources: z.array(SuperApiResource),
  calendars: z.array(SuperApiCalendar),
  events: z.array(SuperApiTask),
});

export type SuperApiResponse = z.infer<typeof SuperApiSchema>;
